import React from "react"
import "./styles/footer.scss"

export default ({ children }) => (
    <footer>
        <p>&copy; 2020 ShortOrme Productions</p>            
    </footer>
)